var map = {
	"./Slide000.avif": 9906,
	"./Slide001.avif": 164,
	"./Slide002.avif": 5509,
	"./Slide01.webp": 9278,
	"./Slide02.webp": 2285,
	"./Slide03.webp": 9345,
	"./Slide04.webp": 7983,
	"./Slide05.webp": 5313,
	"./Slide06.webp": 108,
	"./Slide07.webp": 7586,
	"./Slide08.webp": 2664,
	"./Slide09.webp": 6643,
	"./Slide10.webp": 9142,
	"./Slide11.webp": 8009,
	"./Slide12.webp": 8320,
	"./Slide13.webp": 7336,
	"./Slide14.webp": 7848,
	"./Slide15.webp": 3227,
	"./Slide16.webp": 2480,
	"./Slide17.webp": 5927,
	"./Slide18.webp": 4059,
	"./Slide19.webp": 8707,
	"./Slide20.webp": 2775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9397;